module.exports = __webpack_public_path__ + "static/jinal-8afc4e46b004264475ad1066e0a7c823.jpg";